"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("../styles/App.css");
require("../styles/NavMenu.css");
var _img_menu_RD_nav = _interopRequireDefault(require("../assets/img_menu_R&D_nav.png"));
var _img_menu_customers_nav = _interopRequireDefault(require("../assets/img_menu_customers_nav.png"));
var React = _interopRequireWildcard(require("react"));
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _Menu = _interopRequireDefault(require("@mui/material/Menu"));
var _MenuItem = _interopRequireDefault(require("@mui/material/MenuItem"));
var _Divider = _interopRequireDefault(require("@mui/material/Divider"));
var _dist = require("package_ui_ihm/dist");
var _reactRouterDom = require("react-router-dom");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /**
* Nom : NavMenu.js
* Description : Ce fichier contient la définition du composant NavMenu 
*               Ce composant est un menu déroulant avec des liens pour naviguer sur l'application
* Date de création : 23 septembre 2024
*/ /* CSS et assets */ /* Bibliothèques et composants */ /* Hook */ /**
* NavMenu : ce composant est un menu déroulant avec des liens pour naviguer sur l'application
*
* Type : composant 
*
* Parametres : 
*  - children -- contient l'élément à afficher quand le menu est fermé 
*/
function NavMenu(_ref) {
  var children = _ref.children,
    name_app = _ref.name_app;
  // Define useState hooks and variable
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    anchor = _React$useState2[0],
    setAnchor = _React$useState2[1];
  var open = Boolean(anchor);

  // Define useContext hooks
  var _useAuth = (0, _dist.useAuth)(),
    logout = _useAuth.logout,
    currentUser = _useAuth.currentUser;
  var navigate = (0, _reactRouterDom.useNavigate)();

  // Define functions
  var handleClick = function handleClick(event) {
    setAnchor(event.currentTarget);
  };
  var handleClose = function handleClose() {
    setAnchor(null);
  };
  var handleLink = function handleLink(event, path) {
    event.preventDefault();
    handleClose();
    navigate(path);
  };
  var handleLogout = function handleLogout(event) {
    console.log('checkUnitaryTest');
    event.preventDefault();
    logout();
  };

  // Render component
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Button["default"]
    /*id="basic-button"
    aria-controls={open ? 'basic-menu' : undefined}*/, {
      "aria-haspopup": "true",
      "aria-expanded": open ? 'true' : undefined,
      onClick: handleClick,
      children: children
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Menu["default"], {
      id: "basic-menu",
      anchorEl: anchor,
      open: open,
      onClose: handleClose
      /*MenuListProps={{
          'aria-labelledby': 'basic-button',
      }}*/,
      children: name_app === "BOXIBRAIN" ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        children: [currentUser["role_name"] === "AT_ADMIN" || currentUser["role_name"] === "AT_RESEARCH" ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
          onClick: function onClick(e) {
            return handleLink(e, "/targets");
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "menu-link",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
              src: _img_menu_RD_nav["default"],
              alt: "goto_R&D_section",
              className: "link-img"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: "link-text",
              children: "R&D"
            })]
          })
        }) : null, currentUser["role_name"] === "AT_ADMIN" || currentUser["role_name"] === "AT_RESEARCH" || currentUser["role_name"] === "AT_SUPPORT" ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
          onClick: function onClick(e) {
            return handleLink(e, "/equipments");
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "menu-link",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
              src: _img_menu_customers_nav["default"],
              alt: "goto_customers_section",
              className: "link-img"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: "link-text",
              children: "Gestion clients"
            })]
          })
        }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_Divider["default"], {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
          onClick: function onClick(e) {
            return handleLink(e, "/statistics");
          },
          children: "Statistiques"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
          onClick: function onClick(e) {
            return handleLink(e, "/help");
          },
          children: "Aide"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Divider["default"], {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
          onClick: handleLogout,
          children: "Se d\xE9connecter"
        })]
      }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
          onClick: function onClick(e) {
            return handleLink(e, "/help");
          },
          children: "Aide"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Divider["default"], {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
          onClick: handleLogout,
          children: "Se d\xE9connecter"
        })]
      })
    })]
  });
}
var _default = exports["default"] = NavMenu;